"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remCalc = remCalc;
exports.emCalc = emCalc;

var _sizes = require("HubStyleTokens/sizes");

function remCalc(size) {
  return parseInt(size, 10) + "px";
}

function emCalc(size) {
  return parseInt(size, 10) / parseInt(_sizes.ROOT_FONT_SIZE, 10) + "em";
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/core/Style.js
// module id = 388
// module chunks = 5 6 7